<template>
  <div v-if="isMine">
    <!-- Чатууд / Холбоо барих — дээд мөрний чат товчоор нээгдэнэ -->
    <v-navigation-drawer
      ref="listDrawer"
      v-model="listOpen"
      class="city-drawer"
      right
      fixed
      temporary
      hide-overlay
      :width="$vuetify.breakpoint.smAndDown ? '100%' : 460"
    >
      <div class="d-flex align-center px-5 pt-5 pb-2">
        <v-btn
          v-if="tab === 1"
          icon
          class="mr-1"
          title="Буцах"
          @click="tab = 0"
        >
          <v-icon color="grey darken-1">mdi-arrow-left</v-icon>
        </v-btn>
        <span class="chat-title">
          {{ tab === 1 ? "Хэнтэй чатлах вэ" : "Чат" }}
        </span>
        <v-spacer />
        <v-btn v-if="tab === 0 && !national" icon title="Шинэ чат" @click="tab = 1">
          <v-icon color="grey darken-1">mdi-square-edit-outline</v-icon>
        </v-btn>
        <v-btn icon title="Хаах" @click="listOpen = false">
          <v-icon color="grey darken-1">mdi-close</v-icon>
        </v-btn>
      </div>
      <v-divider />

      <!-- Чатууд -->
      <div v-if="tab === 0">
        <div class="px-4 py-3">
          <v-text-field
            v-model="roomQuery"
            dense
            rounded
            filled
            flat
            hide-details
            background-color="grey lighten-4"
            prepend-inner-icon="mdi-magnify"
            placeholder="Хайх..."
          />
          <v-select
            v-if="!national"
            v-model="roomSchool"
            :items="roomSchoolOptions"
            item-text="text"
            item-value="value"
            dense
            rounded
            filled
            flat
            hide-details
            background-color="grey lighten-4"
            class="mt-2"
          />
          <div v-if="!national" class="d-flex mt-2">
            <v-chip
              v-for="option in filters"
              :key="option.value"
              small
              class="mr-2"
              :color="filter === option.value ? 'green' : 'grey lighten-4'"
              :text-color="filter === option.value ? 'white' : 'grey darken-1'"
              @click="filter = option.value"
            >
              {{ option.text }}
            </v-chip>
          </div>
        </div>
        <v-divider />

        <div v-if="loadingRooms" class="py-8 text-center">
          <v-progress-circular indeterminate color="green" size="22" />
        </div>
        <div
          v-else-if="!visibleRooms.length && !waitingContacts.length"
          class="py-8 px-5 text-center grey--text text-body-2"
        >
          {{ national ? "Чат алга" : "Чат алга — «Холбоо барих»-аас эхлүүлнэ" }}
        </div>
        <v-list v-else class="py-0">
          <v-list-item
            v-for="room in visibleRooms"
            :key="room.id"
            class="px-4"
            @click="openRoom(room)"
          >
            <v-avatar :color="colorOf(room)" size="52" class="mr-3">
              <v-img v-if="photoOf(room)" :src="photoOf(room)" />
              <span v-else class="white--text text-subtitle-2">
                {{ initial(titleOf(room)) }}
              </span>
            </v-avatar>
            <v-list-item-content>
              <v-list-item-title class="text-body-2 font-weight-medium">
                {{ titleOf(room) }}
              </v-list-item-title>
              <!-- Чатын төрөл — сургуулийн чатын жагсаалттай ижил. -->
              <div>
                <span
                  class="type-chip"
                  :class="room.type === 'group' ? 'is-group' : 'is-direct'"
                >
                  {{ room.type === "group" ? "Групп" : "Хувийн" }}
                </span>
              </div>
              <!-- Аль сургуулийнх нь хамгийн чухал. -->
              <!-- Албан тушаал саарал, сургуулийн нэр тод. -->
              <v-list-item-subtitle
                v-if="subtitleOf(room)"
                class="text-caption wrap-text"
              >
                <span style="color: #6a6a6a">{{ roleOf(room) }}</span>
                <span v-if="placeOf(room)" style="color: #6a6a6a"> · </span>
                <span
                  v-if="placeOf(room)"
                  class="font-weight-bold"
                  style="color: #344767"
                  >{{ placeOf(room) }}</span
                >
              </v-list-item-subtitle>
              <v-list-item-subtitle class="text-caption">
                {{ room.lastMessage || "Мессеж алга" }}
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-badge
              v-if="unread[room.id]"
              :content="unread[room.id]"
              color="#ef4444"
              inline
            />
          </v-list-item>
          <!-- Өрөө үүсээгүй ч хариуцсан сургуулиудын эрхтэй хүмүүс
               чат мэт харагдана — дарахад өрөө нь үүснэ. -->
          <v-list-item
            v-for="person in waitingContacts"
            :key="'c-' + person.id"
            class="px-4"
            @click="pick(person)"
          >
            <v-avatar :color="avatarColor(person.id)" size="52" class="mr-3">
              <v-img v-if="person.photoURL" :src="person.photoURL" />
              <span v-else class="white--text text-subtitle-2">
                {{ initial(person.name) }}
              </span>
            </v-avatar>
            <v-list-item-content>
              <v-list-item-title class="text-body-2 font-weight-medium">
                {{ person.name }}
              </v-list-item-title>
              <v-list-item-subtitle class="text-caption wrap-text">
                <span style="color: #6a6a6a">{{ roleLabel(person.role) }}</span>
                <span v-if="person.schoolName" style="color: #6a6a6a"> · </span>
                <span
                  v-if="person.schoolName"
                  class="font-weight-bold"
                  style="color: #344767"
                  >{{ person.schoolName }}</span
                >
              </v-list-item-subtitle>
              <v-list-item-subtitle class="text-caption font-italic">
                -
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </div>

      <!-- Холбоо барих -->
      <div v-else>
        <div class="px-4 pt-3">
          <!-- Байгаа группд гишүүн нэмэх горим. -->
          <div
            v-if="addingTo"
            class="d-flex align-center mb-3 px-1 text-caption"
          >
            <span class="font-weight-bold">
              «{{ titleOf(addingTo) }}»-д нэмэх
            </span>
            <v-spacer />
            <v-btn small text color="grey" @click="cancelAdding">Болих</v-btn>
            <v-btn
              small
              color="green"
              dark
              depressed
              :disabled="!chosen.length"
              :loading="starting"
              @click="confirmAdd"
            >
              Нэмэх ({{ chosen.length }})
            </v-btn>
          </div>

          <!-- Сургуулийн чаттай ижил сонголт. -->
          <v-btn-toggle
            v-if="!addingTo"
            v-model="groupMode"
            dense
            mandatory
            color="green"
            class="mb-3"
          >
            <v-btn :value="false" small>Хувийн чат</v-btn>
            <v-btn :value="true" small>Групп чат</v-btn>
          </v-btn-toggle>

          <v-select
            v-if="kind !== 'specialist'"
            v-model="schoolId"
            :items="schools"
            item-text="name"
            item-value="id"
            placeholder="Сургууль"
            dense
            rounded
            filled
            flat
            hide-details
            background-color="grey lighten-4"
            :loading="loadingSchools"
            @change="onSchoolChange"
          />
          <v-select
            v-model="kind"
            :items="kinds"
            item-text="text"
            item-value="value"
            placeholder="Хэн"
            dense
            rounded
            filled
            flat
            hide-details
            background-color="grey lighten-4"
            class="mt-2"
            @change="loadPeople"
          />
          <v-select
            v-if="kind === 'student' && classes.length"
            v-model="className"
            :items="classes"
            placeholder="Бүлэг"
            dense
            rounded
            filled
            flat
            hide-details
            background-color="grey lighten-4"
            class="mt-2"
            @change="loadPeople"
          />
          <v-text-field
            v-model="search"
            dense
            rounded
            filled
            flat
            hide-details
            background-color="grey lighten-4"
            prepend-inner-icon="mdi-magnify"
            placeholder="Нэр, эрх, сургуулиар хайх..."
            class="mt-2"
          />
          <div v-if="groupMode && !addingTo" class="d-flex align-center mt-2">
            <span class="text-caption grey--text">
              {{ chosen.length }} хүн сонгосон
            </span>
            <v-spacer />
            <v-btn
              small
              color="green"
              dark
              depressed
              :disabled="!chosen.length"
              :loading="starting"
              @click="startGroup"
            >
              Үүсгэх
            </v-btn>
          </div>
          <v-text-field
            v-if="groupMode && !addingTo"
            v-model="groupName"
            placeholder="Группын нэр"
            dense
            rounded
            filled
            flat
            hide-details
            background-color="grey lighten-4"
            class="mt-2 mb-1"
          />
        </div>

        <div v-if="loadingPeople" class="py-6 text-center">
          <v-progress-circular indeterminate color="green" size="22" />
        </div>
        <v-list v-else class="py-0">
          <v-list-item
            v-for="person in visiblePeople"
            :key="person.id"
            class="px-4"
            @click="pick(person)"
          >
            <v-checkbox
              v-if="groupMode || addingTo"
              :input-value="chosen.some((c) => c.id === person.id)"
              dense
              hide-details
              class="mt-0 pt-0 mr-2"
              readonly
            />
            <v-avatar :color="avatarColor(person.id)" size="36" class="mr-3">
              <v-img v-if="person.photoURL" :src="person.photoURL" />
              <span v-else class="white--text text-caption">
                {{ initial(person.name) }}
              </span>
            </v-avatar>
            <v-list-item-content>
              <v-list-item-title class="text-body-2">
                {{ person.name }}
              </v-list-item-title>
              <v-list-item-subtitle class="text-caption">
                {{ roleLabel(person.role) }}
                <span v-if="person.className"> · {{ person.className }}</span>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <div
            v-if="!visiblePeople.length"
            class="py-6 px-5 text-center grey--text text-body-2"
          >
            Хүн олдсонгүй
          </div>
        </v-list>
      </div>
    </v-navigation-drawer>

    <!-- Нэг чат -->
    <v-navigation-drawer
      ref="roomDrawer"
      v-model="roomOpen"
      class="city-drawer"
      right
      fixed
      temporary
      hide-overlay
      :width="$vuetify.breakpoint.smAndDown ? '100%' : 460"
    >
      <template v-if="activeRoom">
        <div class="d-flex align-center px-3 py-3">
          <v-btn icon @click="closeRoom">
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
          <v-avatar :color="colorOf(activeRoom)" size="36" class="mr-2">
            <v-img v-if="photoOf(activeRoom)" :src="photoOf(activeRoom)" />
            <span v-else class="white--text text-subtitle-2">
              {{ initial(titleOf(activeRoom)) }}
            </span>
          </v-avatar>
          <div class="flex-grow-1" style="min-width: 0">
            <div class="text-body-2 font-weight-medium text-truncate">
              {{ titleOf(activeRoom) }}
            </div>
            <div class="text-caption grey--text text-truncate">
              {{
                activeRoom.type === "group"
                  ? (activeRoom.participants || []).length + " гишүүн"
                  : subtitleOf(activeRoom)
              }}
            </div>
          </div>
          <v-menu
            v-if="national"
            v-model="dayMenu"
            :close-on-content-click="false"
            offset-y
            left
          >
            <template #activator="{ on, attrs }">
              <v-btn
                small
                depressed
                rounded
                color="green lighten-5"
                class="text-none px-3 day-btn green--text text--darken-3"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon small left color="green darken-3">mdi-calendar</v-icon>
                {{ dayFrom ? dayTitle(dayShown) : "Бүгд" }}
                <v-icon small right color="green darken-3">mdi-menu-down</v-icon>
              </v-btn>
            </template>
            <v-date-picker
              :value="dayShown || today()"
              :max="today()"
              locale="mn"
              :first-day-of-week="1"
              no-title
              scrollable
              color="green"
              @change="pickDay"
            >
              <v-btn small text color="green" @click="pickDay(today())">Өнөөдөр</v-btn>
              <v-spacer />
              <v-btn small text @click="clearDay">Бүгд</v-btn>
            </v-date-picker>
          </v-menu>
          <v-btn
            v-if="national && activeRoom.type === 'group'"
            icon
            title="Гишүүд"
            @click="toggleMembers"
          >
            <v-icon :color="membersOpen ? 'green' : 'grey darken-1'">
              mdi-account-group-outline
            </v-icon>
          </v-btn>
          <v-btn
            v-if="canAddMembers(activeRoom)"
            icon
            title="Гишүүн нэмэх"
            @click="startAdding"
          >
            <v-icon color="grey darken-1">mdi-account-plus-outline</v-icon>
          </v-btn>
          <v-btn
            v-if="canDelete(activeRoom)"
            icon
            :loading="deleting"
            @click="removeRoom"
          >
            <v-icon color="red">mdi-delete-outline</v-icon>
          </v-btn>
        </div>
        <v-divider />

        <div v-if="membersOpen" class="messages px-0 py-0">
          <div v-if="loadingMembers" class="py-8 text-center">
            <v-progress-circular indeterminate color="green" size="22" />
          </div>
          <v-list v-else dense class="py-0">
            <v-list-item
              v-for="(member, index) in members"
              :key="member.id"
              class="px-3"
            >
              <span class="text-caption grey--text mr-3">{{ index + 1 }}</span>
              <v-avatar :color="avatarColor(member.id)" size="34" class="mr-3">
                <v-img v-if="member.photo" :src="member.photo" />
                <span v-else class="white--text text-caption">
                  {{ initial(member.name) }}
                </span>
              </v-avatar>
              <v-list-item-content>
                <v-list-item-title class="text-body-2">
                  {{ member.name }}
                </v-list-item-title>
                <v-list-item-subtitle class="text-caption">
                  {{ member.label }}
                </v-list-item-subtitle>
              </v-list-item-content>
              <v-chip v-if="member.isAdmin" x-small color="amber" dark>
                Админ
              </v-chip>
            </v-list-item>
          </v-list>
        </div>

        <div
          v-else
          ref="scroller"
          class="messages px-3 py-3"
          @scroll="onScroll"
          @wheel.passive="onWheel"
          @dragover.prevent
          @drop.prevent="dropImage"
        >
          <div ref="scrollBody">
          <div v-if="loadingOlder" class="py-2 text-center">
            <v-progress-circular indeterminate color="green" size="18" width="2" />
          </div>
          <div v-else-if="noOlder" class="py-2 text-center text-caption grey--text">
            Өмнөх мессеж алга
          </div>
          <div v-if="loadingMessages || dayLoading" class="py-8 text-center">
            <v-progress-circular indeterminate color="green" size="22" />
          </div>
          <div
            v-else-if="!shownMessages.length"
            class="py-8 text-center grey--text text-body-2"
          >
            {{ dayFrom ? "Энэ өдөр мессеж алга" : "Мессеж алга" }}
          </div>
          <template v-for="(message, index) in shownMessages">
          <div v-if="stampFor(index)" :key="'s' + message.id" class="chat-stamp">
            {{ stampFor(index) }}
          </div>
          <div
            :key="message.id"
            :data-day="dayOf(message)"
            class="d-flex mb-3 msg-row"
            :class="isMineMessage(message) ? 'justify-end' : 'justify-start'"
          >
            <v-avatar
              v-if="!isMineMessage(message)"
              :color="avatarColor(message.senderId)"
              size="26"
              class="mr-2 mt-1"
            >
              <v-img v-if="senderPhoto(message)" :src="senderPhoto(message)" />
              <span v-else class="white--text" style="font-size: 11px">
                {{ initial(message.senderName) }}
              </span>
            </v-avatar>
            <div
              class="d-flex flex-column msg-col"
              :class="isMineMessage(message) ? 'align-end' : 'align-start'"
            >
            <div
              v-if="!isMineMessage(message) && activeRoom.type === 'group'"
              class="text-caption grey--text mb-1"
            >
              {{ message.senderName
              }}<span v-if="senderSchool(message)"> · {{ senderSchool(message) }}</span>
            </div>
            <div class="bubble-wrap">
            <div
              class="bubble"
              :class="[
                isMineMessage(message) ? 'mine' : 'theirs',
                message.type === 'poll' && !message.isDeleted ? 'bubble-poll' : '',
              ]"
              @mousedown="_pressStart(message, $event)"
              @mouseup="_pressEnd"
              @mouseleave="_pressEnd"
              @touchstart="_pressStart(message, $event)"
              @touchmove="_pressEnd"
              @touchend="_pressEnd"
              @touchcancel="_pressEnd"
              @dblclick="_quickLike(message)"
              @contextmenu.prevent="_openReactions(message, $event)"
            >
              <div
                v-if="!message.isDeleted && replyOf(message)"
                class="reply-quote"
              >
                <div class="reply-author">{{ replyOf(message).senderName }}</div>
                <div class="reply-text">{{ replySnippet(replyOf(message)) }}</div>
              </div>
              <div v-if="message.isDeleted" class="text-body-2 font-italic">
                Устгасан мессеж
              </div>
              <chat-poll
                v-else-if="message.type === 'poll'"
                :school="null"
                :room-id="activeRoom.id"
                :message="message"
                :me="me"
                :mine="isMineMessage(message)"
              />
              <div
                v-else-if="message.type === 'image'"
                class="chat-image"
                @click="viewImage(message.content)"
              >
                <v-img :src="message.content" max-width="220" class="rounded" />
              </div>
              <div v-else class="text-body-2 msg-text">
                <template v-for="(part, i) in messageParts(message.content, message.mentions, me && me.id)">
                  <span
                    v-if="part.mention"
                    :key="i"
                    class="chat-mention"
                    :class="{ 'chat-mention-me': part.me }"
                    >{{ part.text }}</span
                  >
                  <a
                    v-else-if="part.href"
                    :key="i"
                    :href="part.href"
                    target="_blank"
                    rel="noopener"
                    class="chat-link"
                    >{{ part.text }}</a
                  >
                  <template v-else>{{ part.text }}</template>
                </template>
              </div>
              <div
                v-if="canResolve && !isMineMessage(message) && !message.isDeleted"
                class="action-row"
              >
                <button
                v-for="item in chatActions"
                :key="item.id"
                type="button"
                class="action-pill"
                :class="{ on: _actionOn(message, item) }"
                @click="pickAction(message, item)"
              >
                {{ item.mn }}
                  </button>
              </div>
            </div>
            <div
              v-if="!message.isDeleted"
              class="msg-tools"
              :class="isMineMessage(message) ? 'tools-left' : 'tools-right'"
            >
              <v-btn icon small title="Реакц" @click="_openReactions(message, $event)">
                <v-icon size="18" color="grey darken-1">mdi-emoticon-happy-outline</v-icon>
              </v-btn>
              <v-btn icon small title="Хариулах" @click="startReply(message)">
                <v-icon size="18" color="grey darken-1">mdi-reply</v-icon>
              </v-btn>
              <v-btn
                v-if="isMineMessage(message) || isSuperAdmin"
                icon
                small
                title="Бусад"
                @click="openMore(message, $event)"
              >
                <v-icon size="18" color="grey darken-1">mdi-dots-vertical</v-icon>
              </v-btn>
            </div>
            </div>
            <div v-if="_hasReactions(message)" class="reaction-row" @click="_openReactionPeople(message)">
              <span class="reaction-chip">
                <span
                  v-for="emoji in _reactionEmojiList(message)"
                  :key="emoji"
                  class="reaction-emoji"
                  >{{ emoji }}</span
                >
                <span v-if="_reactionTotal(message) > 1" class="reaction-total">{{
                  _reactionTotal(message)
                }}</span>
              </span>
            </div>
            <div
              class="text-caption stamp d-flex align-center"
              :class="isMineMessage(message) ? 'justify-end' : ''"
            >
              <v-chip
                v-if="message.action && !canResolve && !message.isDeleted"
                x-small
                color="amber lighten-4"
                text-color="amber darken-4"
                class="mr-1"
              >
                <v-icon x-small left>mdi-check</v-icon>{{ message.action.mn }}
              </v-chip>
              <span v-if="message.isEdited && !message.isDeleted" class="mr-1"
                >Зассан ·</span
              >
              {{ timeOf(message) }}
              <v-icon
                v-if="isMineMessage(message) || isSuperAdmin"
                x-small
                class="ml-1"
                style="cursor: pointer"
                :color="seenBy(message) ? 'green' : 'grey lighten-1'"
                @click.stop="openSeenBy(message)"
              >
                mdi-check-all
              </v-icon>
            </div>
            </div>
          </div>
          </template>
          <div v-if="loadingNewer" class="py-2 text-center">
            <v-progress-circular indeterminate color="green" size="18" width="2" />
          </div>
          </div>
        </div>

        <v-divider />
        <div
          v-if="editTarget || replyTarget"
          class="compose-bar d-flex align-center px-4 pt-2"
        >
          <v-icon x-small class="mr-2">{{
            editTarget ? "mdi-pencil-outline" : "mdi-reply"
          }}</v-icon>
          <div class="flex-grow-1 text-truncate">
            <template v-if="editTarget">Мессеж засаж байна</template>
            <template v-else>
              {{ replyTarget.senderName }}: {{ replySnippet(replyTarget) }}
            </template>
          </div>
          <v-btn icon x-small title="Болих" @click="cancelCompose">
            <v-icon x-small>mdi-close</v-icon>
          </v-btn>
        </div>
        <div class="d-flex align-center px-3 py-2 composer">
          <div v-if="mentionAt !== null && (loadingMembers || mentionMatches.length)" class="mention-panel">
            <div v-if="loadingMembers" class="d-flex align-center px-3 py-3 grey--text text--darken-1">
              <v-progress-circular indeterminate size="18" width="2" color="green" class="mr-3" />
              Ачаалж байна…
            </div>
            <div
              v-for="(person, i) in mentionMatches"
              :key="'mn' + person.id"
              class="d-flex align-center px-3 py-2 mention-row"
              :class="{ 'is-active': i === mentionIndex }"
              @mouseenter="mentionIndex = i"
              @mousedown.prevent="pickMention(person)"
            >
              <span class="mention-num">{{ i + 1 }}</span>
              <v-avatar size="30" :color="avatarColor(person.id)" class="mr-3">
                <img v-if="person.photo" :src="person.photo" />
                <span v-else class="white--text">{{ (person.name || "?").split(".").pop().trim().charAt(0).toUpperCase() }}</span>
              </v-avatar>
              <span class="text-truncate">{{ person.name }}</span>
            </div>
          </div>
          <template v-if="national && isNationalRoom(activeRoom)">
            <v-btn icon small title="Санал асуулга" @click="openPoll">
              <v-icon small color="grey darken-1">mdi-poll</v-icon>
            </v-btn>
            <v-btn
              icon
              small
              title="Зураг илгээх"
              :loading="sendingImage"
              @click="$refs.imageInput.click()"
            >
              <v-icon small color="grey darken-1">mdi-image-outline</v-icon>
            </v-btn>
            <input
              ref="imageInput"
              type="file"
              accept="image/*"
              class="d-none"
              @change="pickImage"
            />
          </template>
          <v-textarea
            ref="draftInput"
            v-model="draft"
            placeholder="Aa"
            auto-grow
            rows="1"
            row-height="20"
            dense
            rounded
            filled
            flat
            hide-details
            background-color="grey lighten-4"
            class="composer-input"
            @input="onDraftInput"
            @keydown="onDraftKeydown"
            @keydown.enter.exact.prevent="onDraftEnter"
          />
          <v-btn
            icon
            color="green"
            class="ml-2"
            :disabled="!draft.trim() || editSaving"
            @click="send"
          >
            <v-icon>mdi-send</v-icon>
          </v-btn>
        </div>
      </template>

      <v-menu
        v-model="reactionOpen"
        :position-x="reactionX"
        :position-y="reactionY"
        absolute
        offset-y
        :close-on-content-click="false"
      >
        <div class="reaction-bar">
          <span
            v-for="emoji in reactionEmojis"
            :key="emoji"
            class="reaction-pick"
            :class="{ mine: _myReaction(reactionTarget) === emoji }"
            @click="_pickReaction(emoji)"
          >
            {{ emoji }}
          </span>
        </div>
      </v-menu>

      <v-menu
        v-model="moreOpen"
        :position-x="moreX"
        :position-y="moreY"
        absolute
        offset-y
      >
        <v-list v-if="moreTarget" dense class="py-1">
          <v-list-item v-if="canEdit(moreTarget)" @click="startEdit(moreTarget)">
            <v-list-item-title>Засах</v-list-item-title>
          </v-list-item>
          <v-list-item v-if="isMineMessage(moreTarget)" @click="removeMessage(moreTarget)">
            <v-list-item-title class="red--text">Устгах</v-list-item-title>
          </v-list-item>
          <v-list-item v-if="isSuperAdmin" @click="hideOne(moreTarget)">
            <v-list-item-title class="red--text">Нуух</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>

      <v-dialog v-model="reactionPeopleOpen" max-width="360">
        <v-card>
          <v-card-title class="text-subtitle-2">
            {{ reactionPeople.length }} реакц
          </v-card-title>
          <v-divider />
          <v-card-text style="max-height: 60vh; overflow-y: auto" class="pa-0">
            <v-list class="py-0">
              <v-list-item v-for="person in reactionPeople" :key="person.id">
                <v-avatar :color="avatarColor(person.id)" size="34" class="mr-3">
                  <v-img v-if="person.photo" :src="person.photo" />
                  <span v-else class="white--text text-caption">
                    {{ initial(person.name) }}
                  </span>
                </v-avatar>
                <v-list-item-content>
                  <v-list-item-title class="text-body-2">
                    {{ person.name }}
                  </v-list-item-title>
                </v-list-item-content>
                <span style="font-size: 20px">{{ person.emoji }}</span>
              </v-list-item>
            </v-list>
          </v-card-text>
          <v-divider />
          <v-card-actions>
            <v-spacer />
            <v-btn text @click="reactionPeopleOpen = false">Хаах</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="seenOpen" max-width="520">
        <v-card>
          <v-card-title class="text-subtitle-2">
            Харсан {{ seenPeople.length }}/{{ seenPeople.length + unseenPeople.length }}
          </v-card-title>
          <v-divider />
          <v-card-text style="max-height: 60vh; overflow-y: auto" class="pa-0">
            <v-list class="py-0">
              <v-subheader v-if="seenPeople.length">Харсан</v-subheader>
              <v-list-item v-for="(person, i) in seenPeople" :key="'s' + person.id">
                <span class="grey--text mr-2" style="width: 26px">{{ i + 1 }}</span>
                <v-avatar :color="avatarColor(person.id)" size="30" class="mr-3">
                  <v-img v-if="person.photo" :src="person.photo" />
                  <span v-else class="white--text">{{ initial(person.name) }}</span>
                </v-avatar>
                <v-list-item-content>
                  <v-list-item-title class="text-body-2">{{ person.name }}</v-list-item-title>
                  <div v-if="person.label" class="grey--text seen-label">{{ person.label }}</div>
                </v-list-item-content>
                <span v-if="person.at" class="grey--text" style="font-size: 13px">
                  {{ seenTime(person.at) }}
                </span>
              </v-list-item>
              <v-subheader v-if="unseenPeople.length">Хараагүй</v-subheader>
              <v-list-item v-for="(person, i) in unseenPeople" :key="'u' + person.id">
                <span class="grey--text mr-2" style="width: 26px">{{ i + 1 }}</span>
                <v-avatar color="grey lighten-2" size="30" class="mr-3">
                  <span class="white--text">{{ initial(person.name) }}</span>
                </v-avatar>
                <v-list-item-content>
                  <v-list-item-title class="text-body-2 grey--text">{{ person.name }}</v-list-item-title>
                  <div v-if="person.label" class="grey--text seen-label">{{ person.label }}</div>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card-text>
          <v-divider />
          <v-card-actions>
            <v-spacer />
            <v-btn text @click="seenOpen = false">Хаах</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="imageViewer" fullscreen>
        <div class="viewer-backdrop" @click="imageViewer = false">
          <div class="viewer-actions" @click.stop>
            <v-btn icon dark class="viewer-action" :loading="downloading" title="Татах" @click="saveImage(viewerSrc)">
              <v-icon>mdi-download</v-icon>
            </v-btn>
            <v-btn icon dark class="viewer-action ml-2" title="Хаах" @click="imageViewer = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
          <img :src="viewerSrc" class="viewer-img" @click.stop />
        </div>
      </v-dialog>

      <v-dialog v-model="pollOpen" max-width="420">
        <v-card>
          <v-card-title class="text-subtitle-1">Санал асуулга</v-card-title>
          <v-divider />
          <v-card-text class="pt-4">
            <v-textarea
              v-model="pollQuestion"
              rows="3"
              auto-grow
              dense
              hide-details
              placeholder="Юу асуух вэ?"
              class="mb-3"
            />
            <div class="text-caption grey--text mb-1">ХАРИУЛТУУД</div>
            <div
              v-for="(option, index) in pollOptions"
              :key="index"
              class="d-flex align-center mb-1"
            >
              <span class="text-caption grey--text mr-2">{{ index + 1 }}</span>
              <v-text-field
                v-model="option.text"
                dense
                hide-details
                :placeholder="index + 1 + '-р хариулт'"
              />
              <v-btn
                v-if="pollOptions.length > 2"
                icon
                small
                @click="pollOptions.splice(index, 1)"
              >
                <v-icon small>mdi-close</v-icon>
              </v-btn>
            </div>
            <v-btn
              v-if="pollOptions.length < 10"
              text
              small
              color="blue"
              @click="pollOptions.push({ text: '' })"
            >
              <v-icon small left>mdi-plus</v-icon> Хариулт нэмэх
            </v-btn>

            <v-switch
              v-model="pollAnonymous"
              dense
              hide-details
              label="Нэрээ нууцлах"
              class="mt-3"
            />
            <v-switch
              v-model="pollMultiple"
              dense
              hide-details
              label="Олон хариулт сонгох"
            />

            <div v-if="pollPresets.length" class="mt-4">
              <div class="poll-swatch-label">ӨНГӨ</div>
              <div class="poll-swatches">
                <div
                  v-for="(preset, index) in pollPresets"
                  :key="index"
                  class="poll-swatch"
                  :style="{
                    background: pollBackgroundOf(preset),
                    border: paleColor(pollBackgroundOf(preset))
                      ? '1px solid #E5E7EB'
                      : 'none',
                  }"
                  @click="pollColorsPick = preset"
                >
                  <v-icon
                    v-if="samePollColors(preset, pollColorsPick)"
                    size="24"
                    :color="pollTextColorOf(preset)"
                  >
                    mdi-check-bold
                  </v-icon>
                  <span v-else :style="{ color: pollTextColorOf(preset) }">Аа</span>
                </div>
              </div>
            </div>
          </v-card-text>
          <v-divider />
          <v-card-actions>
            <v-spacer />
            <v-btn text @click="pollOpen = false">Болих</v-btn>
            <v-btn
              color="green"
              dark
              depressed
              :loading="pollSending"
              @click="askPoll"
            >
              Илгээх
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-navigation-drawer>
  </div>
</template>

<script>
import {
  avatarColor,
  chatBus,
  roomAvatarColor,
  sendImage,
  sendPoll,
  pollColorPresets,
  pollBackgroundOf,
  pollTextColorOf,
  reactionCounts,
  linkifyParts,
  messageParts,
  downloadFile,
  needsStamp,
  stampLabel,
} from "@/chat/chat.js";
import ChatPoll from "@/chat/ChatPoll.vue";

// Үндэсний чатын админы бэлэн хариултууд.
const CHAT_ACTIONS = [
  { id: "ok", en: "OK", mn: "Асуудалгүй" },
  { id: "wait", en: "Wait", mn: "Түр хүлээнэ үү" },
];
import {
  addMembers,
  backfillSchoolRefs,
  watchMyRooms,
  watchMessages,
  touchMyMember,
  watchUnread,
  sendMessage,
  markRead,
  openDirect,
  createGroup,
  deleteRoom,
  isAutoRoom,
  loadClassNames,
  loadContacts,
  loadSchools,
  loadSpecialistList,
  loadStaff,
  loadTeachers,
  loadStudents,
  roleLabel,
  isSpecialist,
  isNationalAdmin,
  isNationalRoom,
  photoForParticipant,
  setReaction,
  setMessageAction,
  editMessage,
  deleteMessage,
  hideMessage,
  watchMessagesOn,
  nearestDay,
  dayKey,
} from "./city_chat.js";

export default {
  components: { ChatPoll },
  name: "CityChatDock",
  data() {
    return {
      listOpen: false,
      roomOpen: false,
      resolving: null,
      tab: 0,

      rooms: [],
      unread: {},
      activeRoom: null,
      messages: [],
      draft: "",
      mentioned: [],
      mentionAt: null,
      mentionQuery: "",
      mentionIndex: 0,
      editTarget: null,
      editSaving: false,
      replyTarget: null,
      dayMenu: false,
      dayFrom: null,
      dayTo: null,
      dayShown: null,
      dayMessages: [],
      stopDay: null,
      dayLoading: false,
      noOlder: false,
      loadingOlder: false,
      loadingNewer: false,
      stuck: true,
      moreOpen: false,
      moreTarget: null,
      moreX: 0,
      moreY: 0,
      loadingRooms: true,
      loadingMessages: false,
      deleting: false,
      membersOpen: false,
      loadingMembers: false,
      members: [],
      memberInfo: {},
      memberCache: {},
      sendingImage: false,
      imageViewer: false,
      downloading: false,
      viewerSrc: "",
      pollOpen: false,
      pollSending: false,
      pollQuestion: "",
      pollOptions: [{ text: "" }, { text: "" }],
      pollAnonymous: true,
      pollMultiple: false,
      pollPresets: [],
      pollColorsPick: null,
      reactionEmojis: ["👍", "❤️", "😂", "😮", "😢", "🙏"],
      reactionOpen: false,
      reactionTarget: null,
      reactionX: 0,
      reactionY: 0,
      reactionPeopleOpen: false,
      seenOpen: false,
      seenPeople: [],
      unseenPeople: [],
      reactionPeople: [],
      pressTimer: null,

      schools: [],
      schoolId: null,
      loadingSchools: true,
      kind: "staff",
      kinds: [
        { text: "Мэргэжилтэн", value: "specialist" },
        { text: "Удирдлага/Ажилчид", value: "staff" },
        { text: "Багш", value: "teacher" },
        { text: "Сурагч", value: "student" },
      ],
      classes: [],
      className: null,
      people: [],
      contacts: [],
      photos: {},
      photoAsked: {},
      loadingPeople: false,
      search: "",
      roomQuery: "",
      roomSchool: "all",
      filter: "all",
      filters: [
        { text: "Бүгд", value: "all" },
        { text: "Хувийн", value: "direct" },
        { text: "Групп", value: "group" },
      ],
      groupMode: false,
      groupName: "",
      chosen: [],
      addingTo: null,
      starting: false,

      stopRooms: null,
      stopMessages: null,
      stopUnread: {},
    };
  },
  computed: {
    mentionMatches() {
      if (this.mentionAt === null) return [];
      const q = this.mentionQuery.toLowerCase();
      return this.members
        .filter((p) => p.id !== this.me.id && String(p.name || "").toLowerCase().includes(q));
    },
    userData() {
      return this.$store.state.userData;
    },
    chatActions() {
      return CHAT_ACTIONS;
    },
    /** Бэлэн хариулт зөвхөн үндэсний өрөөнд, superadmin-д. */
    isSuperAdmin() {
      const role = this.userData && this.userData.role;
      return role === "superadmin" || role === "superadmin2";
    },
    canResolve() {
      const room = this.activeRoom;
      if (!room || !isNationalRoom(room)) return false;
      const role = this.userData && this.userData.role;
      return role === "superadmin" || role === "superadmin2";
    },
    isMine() {
      return isSpecialist(this.userData) || this.national;
    },
    national() {
      return isNationalAdmin(this.userData);
    },
    shownMessages() {
      return this.dayFrom ? this.dayMessages : this.messages;
    },
    year() {
      return this.$store.state.kSchoolStartYear;
    },
    me() {
      const data = this.userData || {};
      const last = data.lastName || data.LAST_NAME || "";
      const first = data.firstName || data.FIRST_NAME || "";
      const picked = data.cityCode2;
      return {
        id: data.id || data.PERSON_ID || "",
        personId: data.PERSON_ID || "",
        name: `${last} ${first}`.trim() || (this.national ? "Админ" : "Мэргэжилтэн"),
        roleLabel: this.national ? "Админ" : "Мэргэжилтэн",
        // Сургуулийн талд «Мэргэжилтэн · Өмнөговь» гэж харагдана.
        cityName:
          picked && picked.name
            ? String(picked.name)
            : data.cityCode
              ? `Аймаг (${data.cityCode})`
              : "",
      };
    },
    totalUnread() {
      return Object.values(this.unread).reduce((sum, n) => sum + n, 0);
    },
    /// Шүүлтийн жагсаалт — «Хэнтэй чатлах вэ»-тэй ижил, хариуцсан бүх
    /// сургууль.
    roomSchoolOptions() {
      return [
        { text: "Бүх сургууль", value: "all" },
        ...this.schools.map((school) => ({
          text: school.name,
          value: school.name,
        })),
      ];
    },

    /// Хараахан чат эхлээгүй хүмүүс — хайлт, шүүлтийг мөн дагана.
    waitingContacts() {
      if (this.filter === "group") return [];

      const talkingTo = new Set();
      for (const room of this.rooms) {
        if (room.type === "group") continue;
        for (const id of room.participants || []) {
          if (id !== this.me.id) talkingTo.add(id);
        }
      }

      const query = String(this.roomQuery || "").toLowerCase().trim();
      return this.contacts.filter((person) => {
        if (talkingTo.has(person.id)) return false;
        if (this.roomSchool !== "all" && person.schoolName !== this.roomSchool) {
          return false;
        }
        if (!query) return true;
        return [person.name, this.roleLabel(person.role), person.schoolName]
          .join(" ")
          .toLowerCase()
          .includes(query);
      });
    },

    /// Нэр, сургууль, сүүлийн мессежээр хайна.
    visibleRooms() {
      const query = String(this.roomQuery || "").toLowerCase().trim();
      return this.rooms.filter((room) => {
        if (this.filter === "group" && room.type !== "group") return false;
        if (this.filter === "direct" && room.type === "group") return false;
        if (this.roomSchool !== "all" && !this.hasSchool(room)) return false;
        if (!query) return true;
        return [
          this.titleOf(room),
          this.subtitleOf(room),
          room.lastMessage || "",
        ]
          .join(" ")
          .toLowerCase()
          .includes(query);
      });
    },
    visiblePeople() {
      const query = String(this.search || "").toLowerCase().trim();
      if (!query) return this.people;
      return this.people.filter((person) =>
        String(person.name).toLowerCase().includes(query),
      );
    },
  },
  async created() {
    if (!this.isMine) return;
    chatBus.$on("toggle-city", this.toggleList);

    this.stopRooms = watchMyRooms(this.me.id, (all) => {
      const rooms = this.national ? all.filter(isNationalRoom) : all;
      this.rooms = rooms;
      this.loadingRooms = false;
      this.watchUnreadCounts(rooms);
      if (this.activeRoom) {
        const fresh = rooms.find((room) => room.id === this.activeRoom.id);
        if (fresh) this.activeRoom = fresh;
      }
      if (this.national) return;
      // Хуучин өрөөнүүдэд сургуулийн ref байхгүй бол нэг удаа нөхнө.
      backfillSchoolRefs(
        rooms,
        this.schools,
        this.me.id,
        this.year,
        this.me.cityName,
      );
    });
    if (this.national) return;

    const cityCode =
      (this.userData || {}).cityCode ||
      ((this.userData || {}).school || {}).cityCode;
    loadContacts(cityCode, this.me.id).then((contacts) => {
      this.contacts = contacts;
    });

    this.schools = await loadSchools(cityCode);
    this.loadingSchools = false;
    // Сургуулиуд ирэхээс өмнө олдоогүй зургуудыг дахин хайна.
    Object.keys(this.photos).forEach((id) => {
      if (!this.photos[id]) {
        this.$delete(this.photos, id);
        this.$delete(this.photoAsked, id);
      }
    });
    if (this.schools.length) {
      this.schoolId = this.schools[0].id;
      this.loadPeople();
    }
  },
  mounted() {
    this.bodyWatch = new ResizeObserver(() => {
      if (this.stuck) this.scrollToBottom();
    });
  },
  updated() {
    const body = this.$refs.scrollBody;
    if (body === this.watchedBody) return;
    this.bodyWatch.disconnect();
    if (body) this.bodyWatch.observe(body);
    this.watchedBody = body;
  },
  beforeDestroy() {
    this.bodyWatch.disconnect();
    this._pressEnd();
    chatBus.$off("toggle-city", this.toggleList);
    if (this.stopRooms) this.stopRooms();
    if (this.stopMessages) this.stopMessages();
    if (this.stopDay) this.stopDay();
    Object.values(this.stopUnread).forEach((stop) => stop && stop());
  },
  methods: {
    roleLabel,
    avatarColor,
    linkifyParts,
    messageParts,
    isNationalRoom,
    _actionOn(message, item) {
      return !!message.action && message.action.id === item.id;
    },
    /** Дахин дарвал тэмдэг арилна, өөрийг нь дарвал солигдоно. */
    async pickAction(message, item) {
      this.resolving = message.id;
      try {
        await setMessageAction(
          this.activeRoom,
          message.id,
          this.me,
          this._actionOn(message, item) ? null : item,
        );
      } catch (error) {
        alert("Тэмдэглэж чадсангүй: " + (error.message || error));
      } finally {
        this.resolving = null;
      }
    },
    toggleList() {
      if (this.roomOpen) {
        this.roomOpen = false;
        this.listOpen = true;
        return;
      }
      this.listOpen = !this.listOpen;
    },
    initial(text) {
      return String(text || "?").trim().charAt(0).toUpperCase();
    },
    photoOf(room) {
      // Өрөөнд бичигдсэн → хүмүүсийн жагсаалт → хүний баримтаас нэг уншилт.
      if (!room) return "";
      if (room.type === "group") return room.photoURL || "";
      const other = (room.participants || []).find((id) => id !== this.me.id);
      if (!other) return "";
      const info = (room.participantInfo || {})[other] || {};
      if (info.photoURL) return info.photoURL;
      const found = (this.contacts || []).find((c) => c.id === other);
      if (found && found.photoURL) return found.photoURL;
      if (this.photos[other] !== undefined) return this.photos[other];
      if (!this.photoAsked[other]) {
        this.$set(this.photoAsked, other, true);
        photoForParticipant(info, other, this.year, this.schools).then(
          (url) => {
            this.$set(this.photos, other, url || "");
          }
        );
      }
      return "";
    },
    colorOf(room) {
      // Сургуулийн чатын өнгөний функц — нэг хүн хоёр газар ижил өнгөтэй.
      return roomAvatarColor(room, this.me.id);
    },
    titleOf(room) {
      if (room.type === "group") return room.name || "Групп";
      const other = (room.participants || []).find((id) => id !== this.me.id);
      return (room.participantNames || {})[other] || room.name || "Чат";
    },
    // «Захирал · 23-р сургууль» мөрийг хоёр хэсэгт хуваана.
    roleOf(room) {
      return String(this.subtitleOf(room) || "").split("·")[0].trim();
    },
    placeOf(room) {
      const parts = String(this.subtitleOf(room) || "").split("·");
      return parts.slice(1).join("·").trim();
    },
    subtitleOf(room) {
      // Зөвхөн хувийн чат дээр — «Захирал · 23-р сургууль».
      if (room.type === "group") return "";
      const info = room.participantInfo || {};
      const other = (room.participants || []).find((id) => id !== this.me.id);
      const one = info[other] || {};
      return [one.role, one.school].filter(Boolean).join(" · ");
    },
    /// Сонгосон сургуулийн хүн энэ өрөөнд байгаа эсэх.
    hasSchool(room) {
      const info = room.participantInfo || {};
      return Object.keys(info).some((id) => {
        if (id === this.me.id) return false;
        const one = info[id] || {};
        if (one.role === "Мэргэжилтэн") return false;
        const school = String(one.school || "").split(" · ")[0];
        return school === this.roomSchool;
      });
    },
    isMineMessage(message) {
      return message.senderId === this.me.id;
    },
    seenBy(message) {
      const readBy = message.readBy || {};
      return Object.keys(readBy).some(
        (id) => id !== message.senderId && readBy[id] === true,
      );
    },
    async openSeenBy(message) {
      const room = this.activeRoom;
      if (!room || room.type !== "group") return;
      if (!this.members.length) await this.loadMembers(room);
      const readBy = message.readBy || {};
      const readAt = message.readAt || {};
      const ms = (v) => (v ? (v.toDate ? v.toDate() : new Date(v)).getTime() : 0);
      const others = this.members.filter((p) => p.id !== message.senderId);
      this.seenPeople = others
        .filter((p) => readBy[p.id] === true)
        .map((p) => ({ ...p, at: readAt[p.id] || null }))
        .sort((a, b) => ms(b.at) - ms(a.at));
      this.unseenPeople = others.filter((p) => readBy[p.id] !== true);
      this.seenOpen = true;
    },
    seenTime(value) {
      const date = value && value.toDate ? value.toDate() : new Date(value);
      const two = (n) => String(n).padStart(2, "0");
      return `${two(date.getMonth() + 1)}/${two(date.getDate())} ${two(date.getHours())}:${two(date.getMinutes())}`;
    },
    timeOf(message) {
      const at = message.timestamp;
      const date = at && at.toDate ? at.toDate() : null;
      if (!date) return "";
      const two = (value) => String(value).padStart(2, "0");
      return `${two(date.getHours())}:${two(date.getMinutes())}`;
    },
    canDelete(room) {
      if (isAutoRoom(room)) return false;
      if (room.type !== "group") return true;
      return (room.admins || []).includes(this.me.id);
    },
    watchUnreadCounts(rooms) {
      // Only a room with something new keeps a message listener; a fully read
      // one counts 0 from its document (same rule as the school chat and the
      // phone). A room that left the list loses its listener the same way.
      const me = this.me.id;
      const read = (room) =>
        !!room.lastMessageId &&
        (room.lastMessageSender === me || (room.lastReadBy || {})[me] === room.lastMessageId);
      const want = new Set(rooms.filter((room) => !read(room)).map((room) => room.id));
      for (const id of Object.keys(this.stopUnread)) {
        if (want.has(id)) continue;
        this.stopUnread[id]();
        delete this.stopUnread[id];
        this.$delete(this.unread, id);
      }

      for (const room of rooms) {
        if (!want.has(room.id) || this.stopUnread[room.id]) continue;
        this.stopUnread[room.id] = watchUnread(room, this.me.id, (count) => {
          this.$set(this.unread, room.id, count);
          chatBus.$emit("unread", this.totalUnread);
        });
      }
    },
    openRoom(room) {
      this.activeRoom = room;
      this.mentioned = [];
      this.mentionAt = null;
      this.messages = [];
      this.editTarget = null;
      this.replyTarget = null;
      this.loadingMessages = true;
      this.listOpen = false;
      this.roomOpen = true;
      this.membersOpen = false;
      this.members = [];
      if (this.stopMessages) this.stopMessages();

      touchMyMember(room, this.me);
      if (this.national && room.type === "group") this.loadMembers(room);

      this.stopMessages = watchMessages(room, this.me.id, (messages) => {
        this.messages = messages;
        this.loadingMessages = false;
        if (!this.dayFrom) this.$nextTick(this.scrollToBottom);
        markRead(room, messages, this.me.id);
      });
      this.clearDay();
      if (this.national) this.pickDay(this.today());
    },
    closeRoom() {
      if (this.stopMessages) this.stopMessages();
      this.stopMessages = null;
      this.roomOpen = false;
      this.listOpen = true;
      this.activeRoom = null;
      this.messages = [];
      this.membersOpen = false;
      this.editTarget = null;
      this.replyTarget = null;
      this.clearDay();
    },
    today() {
      return dayKey(new Date());
    },
    dayOf(message) {
      const at = message.timestamp;
      return at && at.toDate ? dayKey(at.toDate()) : "";
    },
    dayTitle(day) {
      if (day === this.today()) return "Өнөөдөр";
      const [year, month, date] = day.split("-").map(Number);
      const text = `${month}-р сарын ${date}`;
      return year === new Date().getFullYear() ? text : `${year} оны ${text}`;
    },
    pickDay(day) {
      this.dayMenu = false;
      this.stuck = true;
      this.dayFrom = day;
      this.dayTo = day;
      this.dayShown = day;
      this.noOlder = false;
      this.loadingOlder = false;
      this.loadingNewer = false;
      this.dayMessages = [];
      this.dayLoading = true;
      this.watchDays();
    },
    watchDays() {
      if (this.stopDay) this.stopDay();
      this.stopDay = watchMessagesOn(
        this.activeRoom,
        this.me.id,
        this.dayFrom,
        this.dayTo,
        (messages) => {
          const box = this.$refs.scroller;
          const first = this.dayMessages[0];
          const fromBottom = box ? box.scrollHeight - box.scrollTop : 0;
          this.dayMessages = messages;
          this.dayLoading = false;
          this.loadingOlder = false;
          this.loadingNewer = false;
          this.$nextTick(() => {
            const now = this.$refs.scroller;
            if (!now) return;
            if (first && messages.length && messages[0].id !== first.id) {
              // Older days were added on top: keep the reader on the same message.
              now.scrollTop = now.scrollHeight - fromBottom;
            } else if (this.stuck) {
              now.scrollTop = now.scrollHeight;
            }
            this.trackDay();
          });
        },
      );
    },
    async loadOlder() {
      if (!this.dayFrom || this.noOlder || this.loadingOlder || this.loadingNewer) return;
      if (this.dayLoading) return;
      const roomId = this.activeRoom.id;
      const from = this.dayFrom;
      this.loadingOlder = true;
      const day = await nearestDay(
        this.activeRoom,
        this.me.id,
        new Date(`${from}T00:00:00`),
        false,
      );
      if (!this.activeRoom || this.activeRoom.id !== roomId || this.dayFrom !== from) return;
      if (!day) {
        this.noOlder = true;
        this.loadingOlder = false;
        return;
      }
      this.dayFrom = day;
      this.watchDays();
    },
    async loadNewer() {
      if (!this.dayFrom || this.dayTo === this.today()) return;
      if (this.loadingOlder || this.loadingNewer || this.dayLoading) return;
      const roomId = this.activeRoom.id;
      const to = this.dayTo;
      this.loadingNewer = true;
      this.stuck = false;
      const after = new Date(`${to}T00:00:00`);
      after.setDate(after.getDate() + 1);
      const day = await nearestDay(this.activeRoom, this.me.id, after, true);
      if (!this.activeRoom || this.activeRoom.id !== roomId || this.dayTo !== to) return;
      this.dayTo = !day || day >= this.today() ? this.today() : day;
      this.watchDays();
    },
    onScroll(event) {
      const box = event.currentTarget;
      this.stuck = box.scrollHeight - box.scrollTop - box.clientHeight < 80;
      if (box.scrollTop < 40) this.loadOlder();
      this.trackDay();
    },
    onWheel(event) {
      const box = event.currentTarget;
      if (event.deltaY < 0 && box.scrollTop < 40) this.loadOlder();
      if (event.deltaY > 0 && box.scrollHeight - box.scrollTop - box.clientHeight < 40) {
        this.loadNewer();
      }
    },
    trackDay() {
      const box = this.$refs.scroller;
      if (!box || !this.dayFrom) return;
      const top = box.getBoundingClientRect().top;
      for (const row of box.querySelectorAll("[data-day]")) {
        if (row.getBoundingClientRect().bottom > top) {
          this.dayShown = row.dataset.day || this.dayShown;
          return;
        }
      }
    },
    clearDay() {
      this.dayMenu = false;
      this.stuck = true;
      if (this.stopDay) this.stopDay();
      this.stopDay = null;
      this.dayFrom = null;
      this.dayTo = null;
      this.dayShown = null;
      this.noOlder = false;
      this.loadingOlder = false;
      this.loadingNewer = false;
      this.dayMessages = [];
      this.dayLoading = false;
      this.$nextTick(this.scrollToBottom);
    },
    showToday() {
      if (this.dayFrom && this.dayTo !== this.today()) this.pickDay(this.today());
    },
    stampFor(index) {
      const message = this.shownMessages[index];
      const older = index > 0 ? this.shownMessages[index - 1] : null;
      return needsStamp(message, older) ? stampLabel(message.timestamp) : "";
    },
    openMore(message, event) {
      this.moreTarget = message;
      this.moreX = event.clientX;
      this.moreY = event.clientY;
      this.moreOpen = true;
    },
    toggleMembers() {
      this.membersOpen = !this.membersOpen;
      if (!this.membersOpen) this.$nextTick(this.scrollToBottom);
    },
    /** Members subcollection: name, role, school, photo — same rows as the app. */
    async loadMembers(room) {
      const cached = this.memberCache[room.id];
      if (cached) {
        this.memberInfo = cached.info;
        this.members = cached.rows;
        return;
      }
      this.loadingMembers = true;
      try {
        const snap = await room.ref.collection("members").get();
        const admins = room.admins || [];
        const info = {};
        const rows = [];
        snap.forEach((doc) => {
          const data = doc.data() || {};
          info[doc.id] = data;
          rows.push({
            id: doc.id,
            name: data.name || "Хэрэглэгч",
            label: [data.roleLabel, data.school].filter(Boolean).join(" · "),
            photo: data.photoURL || "",
            isAdmin: admins.includes(doc.id),
          });
        });
        rows.sort((a, b) => {
          if (a.isAdmin !== b.isAdmin) return a.isAdmin ? -1 : 1;
          return a.name.localeCompare(b.name, "mn");
        });
        this.memberCache[room.id] = { info, rows };
        this.memberInfo = info;
        this.members = rows;
      } catch (e) {
        console.log("loadMembers", e);
      } finally {
        this.loadingMembers = false;
      }
    },
    senderSchool(message) {
      const known = this.memberInfo[message.senderId];
      return (known && known.school) || "";
    },
    senderPhoto(message) {
      const known = this.memberInfo[message.senderId];
      return (known && known.photoURL) || "";
    },
    async saveImage(url) {
      this.downloading = true;
      try {
        await downloadFile(url);
      } catch (e) {
        this.$swal.fire("", "Зургийг татаж чадсангүй", "warning");
      } finally {
        this.downloading = false;
      }
    },
    viewImage(src) {
      this.viewerSrc = src;
      this.imageViewer = true;
    },
    pickImage(event) {
      const file = event.target.files && event.target.files[0];
      event.target.value = "";
      this.sendImageFile(file);
    },
    dropImage(event) {
      if (!this.national || !isNationalRoom(this.activeRoom)) return;
      const file = event.dataTransfer && event.dataTransfer.files[0];
      if (file && file.type.startsWith("image/")) this.sendImageFile(file);
    },
    async sendImageFile(file) {
      if (!file || !this.activeRoom || this.sendingImage) return;
      this.sendingImage = true;
      try {
        this.showToday();
        await sendImage(null, this.activeRoom, this.me, file);
      } catch (e) {
        console.log("sendImage", e);
        this.popup("", "Зураг илгээгдсэнгүй", "warning");
      } finally {
        this.sendingImage = false;
      }
    },
    async openPoll() {
      this.pollQuestion = "";
      this.pollOptions = [{ text: "" }, { text: "" }];
      this.pollAnonymous = true;
      this.pollMultiple = false;
      if (!this.pollPresets.length) this.pollPresets = await pollColorPresets();
      this.pollColorsPick = this.pollPresets[0] || null;
      this.pollOpen = true;
    },
    async askPoll() {
      this.pollSending = true;
      try {
        this.showToday();
        await sendPoll(null, this.activeRoom, this.me, {
          question: this.pollQuestion,
          options: this.pollOptions.map((option) => option.text),
          anonymous: this.pollAnonymous,
          multiple: this.pollMultiple,
          colors: this.pollColorsPick,
        });
        this.pollOpen = false;
      } catch (e) {
        console.log("sendPoll", e);
        this.popup("", "Санал асуулга илгээгдсэнгүй", "warning");
      } finally {
        this.pollSending = false;
      }
    },
    pollBackgroundOf,
    pollTextColorOf,
    _hasReactions(message) {
      return Object.keys((message || {}).reactions || {}).length > 0;
    },
    _reactionEmojiList(message) {
      const counts = reactionCounts(message);
      return Object.keys(counts).sort((a, b) => counts[b] - counts[a]);
    },
    _reactionTotal(message) {
      return Object.keys((message || {}).reactions || {}).length;
    },
    _myReaction(message) {
      return ((message || {}).reactions || {})[this.me.id] || "";
    },
    _pressStart(message, event) {
      this._pressEnd();
      const point = event && event.touches ? event.touches[0] : event;
      const x = point ? point.clientX : 0;
      const y = point ? point.clientY : 0;
      this.pressTimer = setTimeout(() => this._openReactions(message, x, y), 450);
    },
    _pressEnd() {
      if (this.pressTimer) {
        clearTimeout(this.pressTimer);
        this.pressTimer = null;
      }
    },
    _openReactions(message, x, y) {
      if (message.isDeleted) return;
      const point = x && x.clientX !== undefined ? x : null;
      this.reactionTarget = message;
      this.reactionX = point ? point.clientX : x || 0;
      this.reactionY = point ? point.clientY : y || 0;
      this.reactionOpen = true;
    },
    async _quickLike(message) {
      this._pressEnd();
      if (message.isDeleted) return;
      await this._setReaction(message, this._myReaction(message) === "👍" ? null : "👍");
    },
    async _pickReaction(emoji) {
      const message = this.reactionTarget;
      this.reactionOpen = false;
      if (!message) return;
      await this._setReaction(message, this._myReaction(message) === emoji ? null : emoji);
    },
    async _setReaction(message, emoji) {
      try {
        await setReaction(this.activeRoom, message.id, this.me.id, emoji);
      } catch (e) {
        console.log("реакц хадгалж чадсангүй", e);
      }
    },
    _openReactionPeople(message) {
      const map = (message || {}).reactions || {};
      const names = (this.activeRoom || {}).participantNames || {};
      this.reactionPeople = Object.keys(map)
        .map((id) => {
          const known = this.memberInfo[id] || {};
          return {
            id: id,
            name: known.name || names[id] || "Хэрэглэгч",
            photo: known.photoURL || "",
            emoji: map[id],
          };
        })
        .sort((a, b) => a.name.localeCompare(b.name, "mn"));
      this.reactionPeopleOpen = this.reactionPeople.length > 0;
    },
    samePollColors(a, b) {
      if (!a || !b) return false;
      return (a.bg || "") === (b.bg || "") && (a.text || "") === (b.text || "");
    },
    paleColor(hex) {
      const digits = String(hex).replace("#", "");
      if (digits.length !== 6) return true;
      const r = parseInt(digits.slice(0, 2), 16) / 255;
      const g = parseInt(digits.slice(2, 4), 16) / 255;
      const b = parseInt(digits.slice(4, 6), 16) / 255;
      return 0.2126 * r + 0.7152 * g + 0.0722 * b > 0.85;
    },
    scrollToBottom() {
      const box = this.$refs.scroller;
      if (box) box.scrollTop = box.scrollHeight;
    },
    // Facebook-style: "@" plus what follows it filters the room's people above the box.
    onDraftInput(value) {
      const text = String(value || "");
      const input = this.$refs.draftInput && this.$refs.draftInput.$refs.input;
      const caret = input ? input.selectionStart : text.length;
      let at = null;
      if (this.activeRoom && this.activeRoom.type === "group" && caret > 0) {
        const i = text.lastIndexOf("@", caret - 1);
        const picked = this.mentioned.some((p) => text.startsWith("@" + p.name, i) && caret >= i + p.name.length + 1);
        const query = i >= 0 ? text.slice(i + 1, caret) : "";
        if (i >= 0 && !picked && (i === 0 || !text[i - 1].trim()) && !query.includes("\n") && query.length <= 25) at = i;
      }
      this.mentionAt = at;
      this.mentionQuery = at === null ? "" : text.slice(at + 1, caret);
      this.mentionIndex = 0;
      if (at !== null && !this.members.length) this.loadMembers(this.activeRoom);
    },
    pickMention(person) {
      const at = this.mentionAt;
      if (at === null) return;
      const input = this.$refs.draftInput && this.$refs.draftInput.$refs.input;
      const caret = Math.max(at + 1, input ? input.selectionStart : this.draft.length);
      const insert = "@" + person.name + " ";
      this.draft = this.draft.slice(0, at) + insert + this.draft.slice(caret);
      if (!this.mentioned.some((p) => p.id === person.id)) this.mentioned.push(person);
      this.mentionAt = null;
      this.mentionQuery = "";
      this.$nextTick(() => {
        if (!input) return;
        input.focus();
        input.setSelectionRange(at + insert.length, at + insert.length);
      });
    },
    // Arrows walk the list, Esc closes it.
    onDraftKeydown(e) {
      if (this.mentionAt === null) return;
      if (e.key === "Escape") {
        e.preventDefault();
        e.stopPropagation();
        this.mentionAt = null;
        return;
      }
      const n = this.mentionMatches.length;
      if (!n || (e.key !== "ArrowDown" && e.key !== "ArrowUp")) return;
      e.preventDefault();
      this.mentionIndex = (this.mentionIndex + (e.key === "ArrowDown" ? 1 : -1) + n) % n;
      this.$nextTick(() => {
        const row = this.$el.querySelector(".mention-row.is-active");
        if (row) row.scrollIntoView({ block: "nearest" });
      });
    },
    onDraftEnter() {
      if (this.mentionMatches.length) this.pickMention(this.mentionMatches[this.mentionIndex] || this.mentionMatches[0]);
      else this.send();
    },
    async send() {
      if (this.editTarget) return this.saveEdit();
      const text = this.draft;
      if (!text.trim() || !this.activeRoom) return;
      const replyToId = this.replyTarget ? this.replyTarget.id : null;
      const mentions = [];
      for (const p of this.mentioned) {
        if (text.includes("@" + p.name) && !mentions.some((m) => m.id === p.id)) {
          mentions.push({ id: p.id, name: p.name });
        }
      }
      this.draft = "";
      this.mentionAt = null;
      this.replyTarget = null;
      this.showToday();
      await sendMessage(this.activeRoom, this.me, text, replyToId, mentions);
      this.mentioned = [];
      this.$nextTick(this.scrollToBottom);
    },
    canEdit(message) {
      if (!this.isMineMessage(message) || message.isDeleted) return false;
      return !message.type || message.type === "text";
    },
    replyOf(message) {
      if (!message.replyToId) return null;
      const find = (list) => list.find((m) => m.id === message.replyToId);
      return find(this.shownMessages) || find(this.messages) || null;
    },
    replySnippet(message) {
      if (message.isDeleted) return "Устгасан мессеж";
      if (message.type === "image") return "Зураг";
      if (message.type === "poll") return "Санал асуулга";
      const text = String(message.content || "");
      return text.length > 60 ? text.slice(0, 60) + "…" : text;
    },
    startReply(message) {
      this.editTarget = null;
      this.replyTarget = message;
      this.focusDraft();
    },
    startEdit(message) {
      this.replyTarget = null;
      this.editTarget = message;
      this.draft = message.content || "";
      this.focusDraft();
    },
    cancelCompose() {
      if (this.editTarget) this.draft = "";
      this.editTarget = null;
      this.replyTarget = null;
    },
    focusDraft() {
      this.$nextTick(() => {
        const input = this.$refs.draftInput;
        if (input && input.focus) input.focus();
      });
    },
    async saveEdit() {
      const text = String(this.draft || "").trim();
      const message = this.editTarget;
      if (!message || !text || text === message.content) {
        this.cancelCompose();
        return;
      }
      this.editSaving = true;
      try {
        await editMessage(this.activeRoom, message.id, text);
        this.cancelCompose();
      } catch (e) {
        this.popup("", "Мессежийг засаж чадсангүй", "warning");
      } finally {
        this.editSaving = false;
      }
    },
    // Alerts open inside the visible drawer; a click outside it would close the chat.
    popup(title, text, icon) {
      const options = typeof title === "object" ? title : { title, text, icon };
      const drawer = this.roomOpen ? this.$refs.roomDrawer : this.$refs.listDrawer;
      return this.$swal.fire({ ...options, target: drawer ? drawer.$el : "body" });
    },
    async removeMessage(message) {
      const result = await this.popup({
        title: "Мессежийг устгах уу?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Устга",
        cancelButtonText: "Болих",
      });
      if (!result.isConfirmed) return;
      await deleteMessage(this.activeRoom, message.id);
    },
    async hideOne(message) {
      const result = await this.popup({
        title: "Мессежийг нуух уу?",
        text: "Бүх хүнээс нуугдана, «устгасан» гэж ч харагдахгүй.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Нуух",
        cancelButtonText: "Болих",
      });
      if (!result.isConfirmed) return;
      await hideMessage(this.activeRoom, message.id, this.me);
    },
    async removeRoom() {
      const answer = await this.popup({
        title: "Чатыг устгах уу?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Устгах",
        cancelButtonText: "Болих",
      });
      if (!answer.isConfirmed) return;

      this.deleting = true;
      const error = await deleteRoom(this.activeRoom, this.me.id);
      this.deleting = false;
      if (error) {
        this.popup("Алдаа", error, "warning");
        return;
      }
      this.closeRoom();
    },
    /// Сургууль солигдвол бүлгийн жагсаалт хуучирна.
    onSchoolChange() {
      this.classes = [];
      this.className = null;
      this.loadPeople();
    },

    async loadPeople() {
      const school = this.schools.find((item) => item.id === this.schoolId);
      if (!school && this.kind !== "specialist") return;

      this.loadingPeople = true;
      this.chosen = [];
      try {
        if (this.kind === "specialist") {
          this.people = await loadSpecialistList(this.me.id);
        } else if (this.kind === "teacher") {
          this.people = await loadTeachers(school);
        } else if (this.kind === "student") {
          if (!this.classes.length) {
            this.classes = await loadClassNames(school, this.year);
            this.className = this.classes.length ? this.classes[0] : null;
          }
          this.people = await loadStudents(school, this.year, this.className);
        } else {
          this.people = await loadStaff(school);
        }
      } catch (e) {
        this.people = [];
        this.popup("Алдаа", "Жагсаалт уншигдсангүй", "error");
      } finally {
        this.loadingPeople = false;
      }
    },
    canAddMembers(room) {
      if (isNationalRoom(room)) return false;
      return room.type === "group" && (room.admins || []).includes(this.me.id);
    },
    startAdding() {
      this.addingTo = this.activeRoom;
      this.chosen = [];
      this.roomOpen = false;
      this.listOpen = true;
      this.tab = 1;
    },
    cancelAdding() {
      this.addingTo = null;
      this.chosen = [];
      this.tab = 0;
    },
    async confirmAdd() {
      if (!this.chosen.length || !this.addingTo) return;
      this.starting = true;
      try {
        await addMembers(this.addingTo, this.chosen, this.year);
        const room = this.addingTo;
        this.cancelAdding();
        this.openRoom(room);
      } catch (e) {
        this.popup("Алдаа", "Гишүүн нэмж чадсангүй", "error");
      } finally {
        this.starting = false;
      }
    },
    async pick(person) {
      if (this.groupMode || this.addingTo) {
        const index = this.chosen.findIndex((item) => item.id === person.id);
        if (index === -1) this.chosen.push(person);
        else this.chosen.splice(index, 1);
        return;
      }
      const room = await openDirect(this.me, person, this.year);
      this.tab = 0;
      this.openRoom(room);
    },
    async startGroup() {
      if (!this.chosen.length) return;
      this.starting = true;
      try {
        const room = await createGroup(
          this.me,
          this.chosen,
          this.groupName,
          this.year,
        );
        this.chosen = [];
        this.groupName = "";
        this.groupMode = false;
        this.tab = 0;
        this.openRoom(room);
      } catch (e) {
        this.popup("Алдаа", "Групп үүсгэж чадсангүй", "error");
      } finally {
        this.starting = false;
      }
    },
  },
};
</script>

<style>
/* Vuetify өөрөө 320px-ээр хязгаарладаг — сургуулийн чаттай ижил өргөн. */
.city-drawer {
  max-width: none !important;
}
</style>

<style scoped>
.type-chip {
  display: inline-block;
  padding: 1px 7px;
  border-radius: 6px;
  font-size: 10px;
  font-weight: 700;
  margin: 2px 0;
}

.type-chip.is-group {
  background: rgba(37, 99, 235, 0.1);
  color: #2563eb;
}

.type-chip.is-direct {
  background: rgba(22, 163, 74, 0.1);
  color: #16a34a;
}

.chat-title {
  font-size: 20px;
  font-weight: 700;
  color: #1e293b;
}
/* Сургуулийн нэр олон байсан ч бүтнээр нь — мөр таслана. */
.wrap-text {
  white-space: normal !important;
  overflow: visible !important;
  text-overflow: unset !important;
  line-height: 1.35;
}
.city-drawer {
  display: flex;
  flex-direction: column;
}

.messages {
  flex: 1;
  overflow-y: auto;
  background: #fafafa;
  height: calc(100vh - 150px);
}

.bubble {
  max-width: 76%;
  padding: 8px 12px;
  border-radius: 15px;
}

.bubble.mine {
  background: #0084ff;
  color: #fff;
}

.bubble.theirs {
  background: #f0f0f0;
  color: #1f2937;
}

.msg-text {
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}

.chat-link {
  color: inherit;
  text-decoration: underline;
}
.composer {
  position: relative;
}
.mention-panel {
  position: absolute;
  left: 12px;
  right: 12px;
  bottom: calc(100% + 4px);
  z-index: 10;
  max-height: 220px;
  overflow-y: auto;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
}
.mention-row {
  cursor: pointer;
  font-size: 15px;
}
.mention-row:hover,
.mention-row.is-active {
  background: #e8f0fe;
}
.viewer-backdrop {
  position: relative;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.92);
}
.viewer-actions {
  position: absolute;
  top: 16px;
  right: 16px;
  display: flex;
}
.viewer-action {
  background: rgba(255, 255, 255, 0.15);
}
.viewer-img {
  max-width: 92vw;
  max-height: 88vh;
  object-fit: contain;
}
.mention-num {
  width: 28px;
  flex-shrink: 0;
  color: #64748b;
  font-size: 13px;
}
.chat-mention {
  color: #2563eb;
  font-weight: 600;
}
.chat-mention-me {
  background: rgba(37, 99, 235, 0.15);
  border-radius: 4px;
  padding: 0 2px;
}
.bubble.mine .chat-mention {
  color: inherit;
}
.bubble.mine .chat-mention-me {
  background: rgba(255, 255, 255, 0.25);
}

.msg-col {
  max-width: 74%;
}

.day-btn {
  border: 1px solid #a5d6a7 !important;
  font-size: 13px !important;
}

.chat-stamp {
  margin: 6px 0 14px;
  text-align: center;
  font-size: 12px;
  font-weight: 600;
  color: #8a8d91;
}

.bubble-wrap {
  position: relative;
  max-width: 100%;
}

.msg-tools {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  display: none;
  white-space: nowrap;
}

.msg-tools.tools-right {
  left: 100%;
  padding-left: 4px;
}

.msg-tools.tools-left {
  right: 100%;
  padding-right: 4px;
  flex-direction: row-reverse;
}

.msg-row:hover .msg-tools {
  display: flex;
}

.msg-col .bubble {
  max-width: 100%;
}

.reply-quote {
  border-left: 3px solid currentColor;
  padding: 2px 0 2px 8px;
  margin-bottom: 4px;
  opacity: 0.8;
  font-size: 12px;
}
.reply-author {
  font-weight: 600;
}
.reply-text {
  max-width: 220px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.compose-bar {
  font-size: 12px;
  color: #475569;
}

.action-row {
  display: flex;
  justify-content: flex-end;
  gap: 6px;
  margin-top: 6px;
}
.action-pill {
  font-size: 12px;
  line-height: 1;
  padding: 5px 11px;
  border-radius: 999px;
  color: #dc2626;
  background: #fff;
  border: 1px solid #fca5a5;
  cursor: pointer;
}
.action-pill:hover {
  background: #fef2f2;
}
.action-pill.on {
  background: #fde68a;
  border-color: #fcd34d;
  color: #78350f;
  font-weight: 600;
}

.reaction-row {
  position: relative;
  z-index: 1;
  display: flex;
  gap: 4px;
  margin-top: -10px;
  padding: 0 10px;
  cursor: pointer;
}

.reaction-chip {
  display: inline-flex;
  align-items: center;
  padding: 2px 6px;
  border-radius: 20px;
  border: 2px solid #fff;
  background: #f0f0f0;
  color: #6b7280;
  font-size: 12px;
  line-height: 1.3;
}

.reaction-emoji + .reaction-emoji {
  margin-left: 1px;
}

.reaction-total {
  margin-left: 4px;
  font-size: 11px;
}

.seen-label {
  font-size: 13px;
  white-space: normal;
  line-height: 1.3;
}
.reaction-bar {
  display: flex;
  gap: 4px;
  padding: 6px;
  border-radius: 32px;
  background: #fff;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.16);
}

.reaction-pick {
  padding: 6px;
  border-radius: 50%;
  font-size: 28px;
  line-height: 1;
  cursor: pointer;
}

.reaction-pick:hover {
  background: #f0f0f0;
}

.reaction-pick.mine {
  background: rgba(0, 132, 255, 0.15);
}

.bubble.bubble-poll {
  max-width: 92%;
  width: 300px;
  padding: 0;
  background: transparent;
  border: none;
}

.chat-image {
  cursor: pointer;
}

.poll-swatch-label {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.8px;
  color: #757575;
  margin-bottom: 8px;
}

.poll-swatches {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 8px;
}

.poll-swatch {
  display: flex;
  align-items: center;
  justify-content: center;
  aspect-ratio: 1;
  border-radius: 50%;
  font-size: 17px;
  cursor: pointer;
}

.stamp {
  font-size: 11px;
  color: #8a8d91;
  margin-top: 3px;
}

/* Урт бичвэрт олон мөр болж өсдөг, гэхдээ бүх дэлгэцийг эзлэхгүй. */
.composer-input ::v-deep textarea {
  max-height: 120px;
  overflow-y: auto;
}

.composer {
  background: #fff;
}
</style>
